<p-button
  icon="pi pi-comment"
  text
  rounded
  size="small"
  [styleClass]="'p-button-icon-only ' + (control()?.value ? 'text-red' : 'text-white')"
  (onClick)="openModal()"
  [pTooltip]="'common.comment' | transloco"
  [disabled]="isReadOnly() && !control()?.value"
>
  <span class="sr-only">
    {{ 'project.steps.rfd.evaluation.comment.title' | transloco }}
  </span>
</p-button>

<app-comment-modal-x
  [(visible)]="modalVisible"
  [isReadOnly]="isReadOnly()"
  [(commentContainer)]="activeCommentContainer"
  (save)="onSave($event)"
></app-comment-modal-x>
